module.exports = __webpack_public_path__ + "static/media/assignments.5925e537.svg";